<template>
	<div>
		<v-dialog
			v-model="dialogData.show"
			persistent
			:max-width="tab === 0 ? 700 : 580"
		>
			<v-form
				ref="form"
				:disabled="submitLoading || Boolean($route.query.deliveryId)"
				@submit.prevent="submit"
			>
				<v-card>
					<v-card-title class="justify-center text-capitalize primary--text">
						<v-btn @click="dialogData.show = false" icon>
							<v-icon>$close</v-icon>
						</v-btn>
						<v-spacer/>
						<span v-if="tab === 0" class="me-8">
							{{!itemData ? $T('add-contract') : $T('edit-contract')}}
						</span>
						<span v-else-if="!$route.query.deliveryId" class="me-8">
							{{!itemData ? $T('add-delivery') : $T('edit-delivery')}}
						</span>
						<span v-else class="me-8">
							{{$T('preview-delivery')}}
						</span>
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-0">
						<v-row dense class="mb-1">
							<!-- contract-no -->
							<v-col
								v-if="dialogData.subContractNo || tab === 1"
								:sm="tab === 0 ? 2 : 3"
								cols="12"
							>
								<v-text-field
									v-model="dialogData.subContractNo"
									:label="$T('inputs.no')"
									outlined
									dense
									:readonly="tab === 0 || Boolean(itemData)"
									hide-details
									@change="
										tab === 1
											? (() => {
												dialogData.clientId = null;
												fetchData({ subContractNo: dialogData.subContractNo });
											})()
											: null
									"
								/>
							</v-col>

							<!-- client -->
							<v-col :sm="tab === 0 ? 4 : 5" cols="12">
								<v-autocomplete
									v-model="dialogData.clientId"
									:label="$T('inputs.client')"
									:items="customers"
									item-text="name"
									item-value="id"
									outlined
									dense
									hide-details
									:loading="tab === 1 ? contractLoading : false"
									:disabled="submitLoading || Boolean(itemData) || tab === 1"
									:rules="rules.required"
								/>
							</v-col>
							
							<v-col :sm="tab === 0 ? 3 : 4" cols="12">
								<v-autocomplete
									v-model="dialogData.ownerId"
									:label="$T('inputs.owner')"
									:items="[{id: null, name: 'Ugarit', type: 1 }, ...owners]"
									item-text="name"
									item-value="id"
									outlined
									dense
									hide-details
									:disabled="submitLoading || tab === 1"
									:loading="tab === 1 ? contractLoading : false"
								/>
							</v-col>
							
							<!-- sale-offer -->
							<v-col v-if="tab === 0" sm="3" cols="12">
								<v-text-field
									v-model.number="dialogData.deviationPercentage"
									:label="$T('inputs.deviation-percentage')"
									outlined
									dense
									hide-details
									prefix=" %"
								/>
							</v-col>
							
							<!-- contract-date / delivery-date -->
							<v-col :sm="tab === 0 ? 3 : 4" cols="12">
								<bee-date-picker
									v-model="dialogData.date"
									menu-picker
									:input-label="$T(`inputs.${tab === 0 ? 'contract' : 'delivery'}-date`)"
									:input-props="{ readonly: true,outlined: true, dense: true }"
									hide-details
									:rules="rules.required"
								/>
							</v-col>
				
							<!-- sale-offer -->
							<v-col v-if="tab === 0" sm="3" cols="12">
								<v-text-field
									v-model.number="dialogData.sale"
									:label="$T('inputs.sale-offer')"
									outlined
									dense
									hide-details
								/>
							</v-col>

							<v-col v-if="tab === 0" sm="3" cols="12">
								<!-- type -->
								<v-autocomplete
									v-model="dialogData.type"
									:label="$T('inputs.type')"
									:items="contractType"
									item-text="name"
									item-value="id"
									outlined
									dense
									hide-details
									:rules="rules.requiredAsNumber"
									:disabled="Boolean(itemData)"
								/>
							</v-col>
						</v-row>
				
						<v-row dense>
							<!-- cardamom -->
							<v-col
								sm="auto"
								cols="12"
								:style="$vuetify.breakpoint.smAndUp ? { width: '48%' } : {}"
							>
								<!-- table -->
								<bee-handy-smart-table
									ref="entiresTable"
									:headers="dialogHeaders"
									:items="dialogData.entries.filter(c => tab === 1 ? c.itemId: true)"
									:items-per-page="-1"
									fixed-header
									:loading="contractLoading"
									dense
									hot-inputs
									hide-default-footer
									hide-inputs-details
									:data-table-props="{ disableSort: true }"
									@change-weight="((item) => item.weight === 0 ? item.price = 0 : null )"
								>
									<template v-slot:item.itemId="{ item }">
										<v-autocomplete
											v-if="tab === 0"
											v-model="item.itemId"
											item-text="name"
											item-value="id"
											:items="flatCardamomItems.filter(c =>
												(!dialogData.entries.map(e => e.itemId).includes(c.itemId) && c.itemCategory === itemCategory.commercial) ||
												c.itemId === item.itemId
											)"
											dense
											hide-details
											clearable
											:disabled="submitLoading || Boolean($route.query.deliveryId)"
											class="mb-4"
											@change="() => {
												if (item.itemId) {
													dialogData.entries.push({
														id: dialogData.entries.length + 1,
														itemId: null,
														weight: 0,
														price: 0
													})
												} else {
													dialogData.entries.pop();
												}
											}"
										/>

										<span v-else>{{getItemById(item.itemId)?.name ?? '-'}}</span>
									</template>

									<template v-slot:item.weight="{ item }">
										<!-- v-model.number="item.weight" -->
										<v-text-field
											:value="item.formattedWeight"
											dense
											hide-details
											:disabled="submitLoading || Boolean($route.query.deliveryId)"
											class="mb-4"
											:rules="item.itemId !== null ? [val => tab === 0 ? +$options.filters.removeNumberFormat(String(val || 0)) > 0 : +$options.filters.removeNumberFormat(String(val || 0)) >= 0] : []"
											@change="item.weight === 0 ? item.price = 0 : null"
											@input="
												item.weight =
													typeof $event === 'string'
														? +$options.filters.removeNumberFormat($event)
														: +$event;
												item.formattedWeight = $options.filters.numberFormat($event);
											"
										/>
									</template>

									<template v-slot:item.price="{ item }">
										<!-- v-model.number="item.price" -->
										<v-text-field
											:value="item.formattedPrice"
											dense
											hide-details
											:disabled="
												!item.weight || submitLoading ||
												Boolean($route.query.deliveryId)
											"
											class="mb-4"
											:rules="item.itemId ? [val => tab === 0 ? +$options.filters.removeNumberFormat(String(val || 0)) > 0 : +$options.filters.removeNumberFormat(String(val || 0)) >= 0] : []"
											@input="
												item.price =
													typeof $event === 'string'
														? +$options.filters.removeNumberFormat($event)
														: +$event;
												item.formattedPrice = $options.filters.numberFormat($event);
											"
										/>
									</template>

									<!-- <template v-slot:item.weight="{ item }">
										<v-text-field
											v-model="item.weight"
											dense
											hide-details
											:disabled="submitLoading || Boolean($route.query.deliveryId)"
											class="mb-4"
											:rules="item.itemId ? [val => tab === 0 ? val.length > 0 : val.length >= 0] : []"
											@change=""
										/>
									</template> -->

									<!-- <template v-slot:item.price="{ item }">
										<v-text-field
											v-model.number="item.price"
											dense
											hide-details
											:disabled="
												!item.weight || submitLoading ||
												Boolean($route.query.deliveryId)
											"
											class="mb-4"
											:rules="item.weight ? [val => val > 0] : []"
										/>
									</template> -->
								</bee-handy-smart-table>
							</v-col>

							<!-- mixes -->
							<v-col
								sm="auto"
								cols="12"
								:style="$vuetify.breakpoint.smAndUp ? { width: '52%' } : {}"
							>
								<bee-handy-smart-table
									:headers="dialogMixesHeaders"
									:items="dialogData.mixes.filter(c => tab === 1 ? c.mixId: true)"
									:items-per-page="-1"
									fixed-header
									:loading="loadingMixItems || contractLoading"
									dense
									hot-inputs
									hide-default-footer
									hide-inputs-details
									:hide-no-data-area="!itemData || tab === 1"
									:data-table-props="{ disableSort: true, singleExpand: true, showExpand: true }"
									@change-weight="(item) => { if (item.weight === 0) item.price = 0; }"
								>
										<!-- v-if="!itemData && tab === 0" -->
									<template v-slot:item.mixId="{ item, index }">
										<v-autocomplete
											v-model="item.mixId"
											item-text="name"
											item-value="id"
											:items="mixes.filter(c =>
												!dialogData.mixes.map(e => e.mixId).includes(c.id) ||
												c.id === item.mixId
											)"
											dense
											hide-details
											clearable
											:disabled="submitLoading || Boolean($route.query.deliveryId)"
											class="mb-4"
											@change="updateMixData(index)"
										/>

									</template>
										<!-- <span v-else>{{getItemById(item.mixId)?.name ?? '-'}}</span> -->
									
									<!-- <template v-slot:item.weight="{ item }">
										<v-text-field
											v-model.number="item.weight"
											dense
											hide-details
											:disabled="submitLoading || Boolean($route.query.deliveryId)"
											class="mb-4"
											:rules="item.mixId ? [val => tab === 0 ? val > 0 : val >= 0] : []"
											
										/>
									</template> -->

									<!-- <template v-slot:item.price="{ item }">
										<v-text-field
											v-model.number="item.price"
											dense
											hide-details
											:disabled="
												!item.weight || submitLoading ||
												Boolean($route.query.deliveryId)
											"
											class="mb-4"
											:rules="item.weight ? [val => val > 0] : []"
										/>
									</template> -->

									<template v-slot:item.weight="{ item }">
										<v-text-field
											:value="item.formattedWeight"
											dense
											hide-details
											:disabled="submitLoading"
											class="mb-4"
											:rules="item.mixId !== null ? [val => tab === 0 ? +$options.filters.removeNumberFormat(String(val || 0)) > 0 : +$options.filters.removeNumberFormat(String(val || 0)) >= 0] : []"
											@change="() => { if (item.weight === 0) item.price = 0; }"
											@input="
												item.weight =
													typeof $event === 'string'
														? +$options.filters.removeNumberFormat($event)
														: +$event;
												item.formattedWeight = $options.filters.numberFormat($event);
											"
										/>
									</template>

									<template v-slot:item.price="{ item }">
										<v-text-field
											:value="item.formattedPrice"
											dense
											hide-details
											:disabled="
												!item.weight || submitLoading ||
												Boolean($route.query.deliveryId)
											"
											class="mb-4"
											:rules="item.weight ? [val => +$options.filters.removeNumberFormat(String(val || 0)) > 0] : []"
											@input="
												item.price =
													typeof $event === 'string'
														? +$options.filters.removeNumberFormat($event)
														: +$event;
												item.formattedPrice = $options.filters.numberFormat($event);
											"
										/>
									</template>

									<!-- expand -->
									<template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
										<v-btn
											v-if="getSumItemsDueKey(item.mixItems) === 100"
											icon small
											@click="expand(!isExpanded)"
										>
											<v-icon :class="{'mdi-rotate-180': isExpanded}">$expand</v-icon>
										</v-btn>
									</template>
									<template v-slot:expanded-item="{ headers, item }">
										<td :colspan="headers.length" class="pa-1">
											<v-data-table
												:headers="[
													{ value: 'itemId', align: 'center' },
													{ value: 'percent', align: 'start' },
												]"
												:items="item.mixItems"
												dense
												hide-default-header
												hide-default-footer
											>
												<template v-slot:item.itemId="{ item: mixItem }">
													{{getItemById(mixItem.itemId)?.name ?? '-'}}
												</template>

												<template v-slot:item.percent="{ item: mixItem }">
													<v-text-field
														v-if="!itemData && tab === 0"
														v-model.number="mixItem.percent"
														type="number"
														min="0"
														max="100"
														dense
														hide-details
														hide-spin-buttons
														:disabled="submitLoading || Boolean($route.query.deliveryId)"
														suffix="%"
														class="mx-auto"
														style="max-width: 80px;"
														:error="getSumItemsDueKey(item.mixItems) !== 100"
														:rules="[() => getSumItemsDueKey(item.mixItems) === 100]"
													/>
													<span v-else>{{mixItem.percent}}%</span>
												</template>
											</v-data-table>
										</td>
									</template>
								</bee-handy-smart-table>
							</v-col>
						</v-row>
						
						<v-divider class="mt-3 mb-2"/>

						<!-- total -->
						<div class="d-flex align-center primary--text font-weight-bold ps-2 text-body-1">
							<span class="font-weight-bold">{{$T('total')}}</span>
							<v-spacer/>
							<span style="width: 140px;">{{
								$options.filters.numberFormat(
									dialogData.entries
										.filter(c => c.weight)
										.reduce((res, c) => res + (c.weight || 0), 0) +
									dialogData.mixes
										.filter(c => c.weight)
										.reduce((res, c) => res + (c.weight || 0), 0)
								)
							}} kg</span>
							<span v-if="tab === 0" style="width: 140px;">{{
								$options.filters.numberFormat(
									dialogData.entries
										.filter(c => c.weight)
										.reduce((res, c) => res + ((c.weight || 0) * (c.price || 0)), 0) +
									dialogData.mixes
										.filter(c => c.weight)
										.reduce((res, c) => res + ((c.weight || 0) * (c.price || 0)), 0)
								)
							}} $</span>
						</div>

					</v-card-text>
					<v-card-actions>
						<v-spacer/>
						<v-btn
							v-if="!$route.query.deliveryId"
							:loading="submitLoading"
							color="primary"
							type="submit"
						>
							{{$T('save')}}
						</v-btn>
						<v-btn :disabled="submitLoading" @click="dialogData.show = false">
							{{$T('close')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			:module-type="tab === 0 ? 'contracts' : 'deliveries'"
			:ids="itemData?.id"
			@on-delete="filter()"
			@input="!$event ? itemData = null : null"
		>
			{{$T('are-you-sure-you-want-to-$', { message: '' })}}
			<span class="text-uppercase alert-color--text">{{$T('delete')}}</span>
			{{$T('the-entry')}}
		</v-delete-dialog>

		<v-dialog v-model="closeDialog" width="400">
			<v-card class="rounded-medium">
				<v-card-title class="py-1">
					<v-btn @click="closeDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
					<v-spacer/>
					<span :class="itemData && !itemData.isCompleted ? 'success--text' : 'orange--text'" class="me-8" >{{$T('confirm')}}</span>
					<v-spacer/>
				</v-card-title>
				<v-card-text class="text-body-1">
					<!--  -->
					{{ itemData && itemData.isCompleted ? $T('are-you-sure-the-contract-is-incomplete') : $T('are-you-sure-the-contract-is-complete') }}
				</v-card-text>
				<v-card-actions class="justify-end">
					<v-btn
						height="34"
						:loading="loading"
						:color="itemData && !itemData.isCompleted ? 'success' : 'orange'"
						dark
						class="rounded-small"
						elevation="1"
						@click="closeContract(itemData)"
					>
						{{$T('ok')}}
					</v-btn>
					<v-btn
						height="34"
						:disabled="loading"
						@click="closeDialog = false"
						elevation="1"
						class="rounded-small"
					>
						{{$T('close')}}
					</v-btn>
				</v-card-actions>
                </v-card>
		</v-dialog>

		<!-- filter -->
		<v-form @submit.prevent="filter()">
			<v-row align="center" dense class="mb-0">
				<!-- contract-no -->
				<v-col lg="1" md="4" sm="6" cols="12">
					<v-text-field
						v-model="filterData.subContractNo"
						:label="$T('inputs.no')"
						dense
						outlined
						hide-details
					/>
				</v-col>

				<!-- client -->
				<v-col lg="2" md="4" sm="6" cols="12">
					<v-autocomplete
						v-model="filterData.clientId"
						:label="$T('inputs.client')"
						:items="customers"
						item-text="name"
						item-value="id"
						dense
						outlined
						clearable
						hide-details
					/>
				</v-col>

				<!-- owners -->
				<v-col lg="2" md="4" sm="6" cols="12">
					<v-autocomplete
						v-model="filterData.ownerId"
						:label="$T('inputs.owner')"
						:items="[{ id: emptyId, name: 'Ugarit' }, ...owners]"
						item-text="name"
						item-value="id"
						dense
						outlined
						clearable
						hide-details
					/>
				</v-col>

				<!-- date -->
				<v-col lg="2" md="4" sm="6" cols="12">
					<bee-date-picker
						v-model="filterData.date"
						:input-label="$T('inputs.date')"
						:input-props="{ dense: true, outlined: true, readonly: true, clearable: true, prependIcon: '$calendar' }"
						menu-picker
						hide-details
					/>
				</v-col>

				<!-- none-completed-only -->
				<v-col lg="2" md="4" sm="6" cols="12">
					<v-autocomplete
						v-model="filterData.noneCompletedOnly"
						:items="[
							{ name: $T('all'), value: null },
							{ name: $T('not-completed'), value: false },
							{ name: $T('completed'), value: true },
						]"
						item-text="name"
						item-value="value"
						dense
						outlined
						hide-details
					/>
					<!-- <v-radio-group v-model="filterData.noneCompletedOnly" row hide-details class="ma-0">
						<v-radio :label="$T('all')" :value="null"/>
						<v-radio :label="$T('not-completed')" :value="false"/>
						<v-radio :label="$T('completed')" :value="true"/>
					</v-radio-group> -->
				</v-col>

				<v-col cols="auto">
					<v-btn small type="submit" color="primary">
						<v-icon>$search</v-icon>
					</v-btn>
				</v-col>
				
				<!-- <v-spacer/> -->

				<!-- add -->
				<v-col v-if="permissions.sales.isReadWrite" cols="auto">
					<v-btn small color="primary" @click="dialogData.show = true">
						<v-icon class="me-1">$add</v-icon>
						{{tab === 0 ? $T('add-contract') : $T('add-delivery')}}
					</v-btn>
				</v-col>

				<v-col>
					<v-btn
						outlined
						:ripple="false"
						color="primary"
						class="me-1 "
						@click="printAll"
						small
					>
						<v-icon>$print</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</v-form>

		<!-- tabs -->
		<v-tabs v-model="tab" in height="30">
			<v-tab :disabled="loading">{{$T('contracts')}}</v-tab>
			<v-tab :disabled="loading">{{$T('delivery')}}</v-tab>
		</v-tabs>
		<v-divider class="mb-3"/>
		<!-- table -->
		<bee-handy-table
			ref="table"
			:headers="tab === 0 ? contractsHeaders : deliveryHeaders"
			:items="[]"
			:items-per-page="20"
			:loading="loading"
			:height="$vuetify.breakpoint.height - (!permissions.statistics.isNone ? 370 : 240)"
			with-columns-divider
			zebra
			dense
			fixed-header
			pagination-on-scroll
			pagination-on-scroll-server-items
			:server-items-length="serverItemsLength"
			hide-no-data-area
			shown-rows-text
			:context-menu-items="contextMenuItems"
			:disable-context-menu="!permissions.sales.isReadWrite"
			:data-table-props="{ disableSort: true }"
			:item-class="item => tab === 1 && item && !item.isDelivered ? 'deep-orange lighten-4' : null"
			table-class="rounded-b-0"
			@contextmenu:row="(e, { item }) => contextMenuPayload = tab == 1 ? item : item"
			@context-menu-add-delivery="({ item }) => {
				itemData = null
				tab = 1;
				dialogData.subContractNo = item.subContractNo;
				dialogData.contractNo = item.contractNo;
				dialogData.show = true;
				fetchData({ subContractNo: item.subContractNo });
			}"
			@context-menu-edit="({ item }) => { itemData = item; dialogData.show = true; }"
			@context-menu-delete="({ item }) => { itemData = item; deleteDialog = true; }"
			@context-menu-change-delivery="({ item }) => changeDeliveryState(item)"
			@context-menu-close="({ item }) => { itemData = item; closeDialog = true; }"
			@pagination-on-scroll:reach-last-row="filter"
		>
			<!-- contract -->
			<!-- total -->
			<template v-slot:item.total="{ item }">
				{{(() => {
					let total = 0;
					itemsHeaders.forEach(({value}) => { 
						total += item[value] 
						? item[value] && item[value].includes('/') 
							? Number(item[value].split('/')[1]) 
							: Number(item[value]) 
						: 0 
					});
					return $options.filters.numberFormat(total);
				})()}}
			</template>

			<template v-slot:item.status="{ item }">
				<v-icon :color="item.isCompleted ? 'success' : 'grey' " > 
					{{ item.isCompleted ? 'mdi-check-circle' : 'mdi-close-circle' }} 
				</v-icon>
			</template>
		</bee-handy-table>

		<bee-handy-table
			:headers="(tab === 0 ? contractsHeaders : deliveryHeaders).map(c => ({
				...c, text: c.value.includes('-') ? c.text: '', class: '', divider: c.value.includes('-')
			}))"
			:items="[]"
			dense
			:hide-default-header="false"
			hide-default-footer
			hide-no-data-area
			:data-table-props="{ disableSort: true }"
			class="statics-table"
			table-class="rounded-t-0"
		>
			<template v-slot:body.append>
				<!-- total-sales -->
				<tr
					class="totals-row text-center"
					:style="!permissions.statistics.isNone ? { bottom: (tab === 0 ? 1 : 2) * 32 + 'px'} : {}"
				>
					<td
						:colspan="tab === 0 ? 6 : 3"
						class="text-start v-data-table__divider"
					>
						{{$T('total-sales')}}
					</td>
					<td
						v-for="(header, index) in itemsHeaders"
						:key="index"
						:class="header.columnClass"
						class="v-data-table__divider"
						:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
					>
						{{(() => {
							const columnTotal = totals.totalSale.find(c => c[header.value]);
							return columnTotal
								? $options.filters.numberFormat(columnTotal[header.value])
								: 0
						})()}}
					</td>
					<td v-if="tab === 0" class="px-1" style="width: 66px; min-width: 66px;">
						{{$options.filters.numberFormat(fixNumber(totalSaleSum, 1))}}
					</td>
				</tr>

				<template v-if="!permissions.statistics.isNone">
					<!-- sale-balance -->
					<tr
						class="totals-row text-center"
						:style="{ bottom: (tab === 0 ? 0 : 1) * 32 + 'px'}"
					>
						<td
							:colspan="tab === 0 ? 6 : 3"
							class="text-start v-data-table__divider"
						>
							{{$T('sale-balance')}}
						</td>
						<td
							v-for="(header, index) in itemsHeaders"
							:key="index"
							:class="header.columnClass"
							class="v-data-table__divider"
							:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
						>
							{{(() => {
								const columnTotal = totals.saleBalances.find(c => c[header.val]);
								return columnTotal
									? $options.filters.numberFormat(columnTotal[header.val])
									: 0
							})()}}
						</td>
						<td v-if="tab === 0" class="px-1" style="width: 66px; min-width: 66px;">
							{{$options.filters.numberFormat(fixNumber(saleBalancesSum, 1))}}
						</td>
					</tr>

					<!-- remaining-qty -->
					<tr
						v-if="!permissions.inventory.isNone"
						class="totals-row text-center"
					>
						<td :colspan="tab === 0 ? 6 : 3" class="text-start v-data-table__divider">
							{{$T('remaining-qty')}}
						</td>
						<td
							v-for="(header, index) in itemsHeaders"
							:key="index"
							:class="header.columnClass"
							class="v-data-table__divider px-1"
							:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
						>
							{{(() => {
								const columnTotal = totals.inventoryQuantity.find(c => c[header.value]);
								return columnTotal
									? $options.filters.numberFormat(columnTotal[header.value])
									: 0
							})()}}
						</td>
						<td v-if="tab === 0" class="px-1" style="width: 66px; min-width: 66px;">
							{{$options.filters.numberFormat(fixNumber(inventoryQuantitySum, 1))}}
						</td>
					</tr>

					<!-- reserved-quantity -->
					<tr class="totals-row text-center">
						<td :colspan="tab === 0 ? 6 : 3" class="text-start v-data-table__divider">
							{{$T('statistics.reserved-quantity')}}
						</td>
					
						<td
							v-for="(header, index) in itemsHeaders"
							:key="index"
							:class="header.columnClass"
							class="v-data-table__divider px-1"
							:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
						>
							{{(() => {
								const columnTotal = totals.reservedQuantity.find(c => c[header.value]);
								return columnTotal
									? $options.filters.numberFormat(columnTotal[header.value])
									: 0
							})()}}
						</td>
					
						<td v-if="tab === 0" class="px-1" style="width: 66px; min-width: 66px;">
							{{$options.filters.numberFormat(fixNumber(reservedQuantitySum, 1))}}
						</td>
					</tr>

					<!-- available-to-sell -->
					<tr class="totals-row text-center">
						<td :colspan="tab === 0 ? 6 : 3" class="text-start v-data-table__divider">
							{{$T('available-to-sell')}}
						</td>
					
						<td
							v-for="(header, index) in itemsHeaders"
							:key="index"
							:class="header.columnClass"
							class="v-data-table__divider px-1"
							:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
						>
							{{(() => {
								const columnTotal = totals.ableToSell.find(c => c[header.value]);
								return columnTotal
									? $options.filters.numberFormat(columnTotal[header.value])
									: 0
							})()}}
						</td>
					
						<td v-if="tab === 0" class="px-1" style="width: 66px; min-width: 66px;">
							{{$options.filters.numberFormat(fixNumber(ableToSellSum, 1))}}
						</td>
					</tr>
				</template>
			</template>
		</bee-handy-table>
	</div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import { emptyId, itemCategory, type, contractType } from '@/helpers/enums';
import rules from '@/helpers/validation-rules';
import { fixNumber, getFlatTree, isEmptyId, toKiloGram, toQuintal } from '@/helpers/functions';
import { generateHtmlPdf } from '@/helpers/generate-html';
import printJS from 'print-js';
export default {
	name: 'Sales',

	data() {
		return {
			emptyId,
			type,
			rules,
			contractType,

			loading: false,
			loadingMixItems: false,
			submitLoading: false,
			contractLoading: false,

			tab: 0,
			itemData: null,
			contextMenuPayload: null,

			deleteDialog: false,

			serverItemsLength: null,
			totals: {
				totalSale: [],
				saleBalances: [],
				inventoryQuantity: [],
				ableToSell: [],
				reservedQuantity: []
			},
			totalSaleSum: 0,
			saleBalancesSum: 0,
			inventoryQuantitySum: 0,
			ableToSellSum: 0,
			reservedQuantitySum: 0,

			// filter
			filterData: {
				subContractNo: null,
				clientId: null,
				ownerId: null,
				date: null,
				noneCompletedOnly: null,
			},

			// data
			dialogData: {
				show: false,
				clientId: null,
				contractId: null,
				ownerId: '',
				date: moment().format('YYYY-MM-DD'),
				contractNo: null,
				contractDate: null,
				sale: null,
				// 
				entries: [{ id: 1, itemId: null, weight: 0, price: 0, formattedPrice: '', formattedWeight: '' }],
				mixes: [{ id: 1, mixId: null, weight: 0, price: 0, mixItems: [], formattedPrice: '', formattedWeight: '' }],
				deviationPercentage: null,
				type: 0,
				subContractNo: null
			},
			itemCategory,
			closeDialog: false,
			itemsWithoutPaging: [],
			statistics: [],
			contractByNo: null
		}
	},

	watch: {
		async 'dialogData.show'(val) {
			if (val) {
				if (this.itemData) {
					this.dialogData.contractNo = this.itemData.contractNo;
					this.dialogData.subContractNo = this.itemData.subContractNo;
					this.dialogData.clientId = this.itemData.clientId;
					this.dialogData.ownerId = this.itemData.ownerId;
					this.dialogData.date = moment(this.itemData.date).format('YYYY-MM-DD');
					this.dialogData.sale = this.itemData.sale;
					this.dialogData.type = this.itemData.type;
					this.dialogData.deviationPercentage = this.itemData.deviationPercentage
					
					this.fetchData({ ...this.itemData, subContractNo: this.itemData.subContractNo });
				} else {
					this.dialogData.date = moment().format('YYYY-MM-DD');
					this.dialogData.type = 0
				}
			} else {
				if (this.$route.query.deliveryId) this.$router.go(-1);
				this.$refs.form.reset();
				this.dialogData.contractNo = null;
				this.itemData = null;
				this.dialogData.ownerId = '';
				this.dialogData.subContractNo = null;
				this.dialogData.contractId = null;
				this.dialogData.entries = [{ id: 1, itemId: null, weight: 0, price: 0, formattedPrice: '', formattedWeight: '' }];
				this.dialogData.mixes = [{ id: 1, mixId: null, weight: 0, price: 0, mixItems: [], formattedPrice: '', formattedWeight: '' }];
				// this.dialogData.type = 0
			}
		},

		tab() {
			this.itemData = null;
			this.filter();
		}
	},

	computed: {
		...mapState({
			permissions: state => state.auth.self.permissions,
			customers: state => state.configs.configsTrees.customers,
			cardamomRootId: state => state.configs.itemsConfigs.cardamomRootId,
			items: state => state.items.items,
			mixes: state => state.items.mixes,
			itemsTree: state => state.items.itemsTree,
			owners: state => state.configs.configsTrees.owners,
		}),
		...mapGetters({
			getAccountById: 'accounts/getAccountById',
			getItemById: 'items/getItemById',
		}),

		contextMenuItems() {
			const items = [
				this.tab === 0 && this.contextMenuPayload
					? {
						title: !this.contextMenuPayload.isCompleted ? this.$T('mark-as-completed') : this.$T('mark-as-incomplete'),
						event: 'close',
						class: !this.contextMenuPayload.isCompleted ? 'success--text' : 'orange--text',
						icon: !this.contextMenuPayload.isCompleted ? '$checkCircleOutline' : '$progressHelper',
						iconClass: 'me-2',
						iconColor: !this.contextMenuPayload.isCompleted ? 'success' : 'orange',
					}
					: null,
					
				(this.tab === 0 && this.contextMenuPayload && !this.contextMenuPayload.isCompleted) || 
				(this.tab === 1)
					? { 
						title: this.$T('edit'), 
						event: 'edit', 
						class: 'warning-color--text',
						icon: '$edit', 
						iconClass: 'me-2', 
						iconColor: 'warning-color'
					}
					: null,
				(this.tab === 0 && this.contextMenuPayload && !this.contextMenuPayload.isCompleted) || 
				(this.tab === 1)
					? { 
						title: this.$T('delete'), 
						event: 'delete', 
						class: 'alert-color--text',
						icon: '$delete', 
						iconClass: 'me-2', 
						iconColor: 'alert-color'
					}
					: null
			];
			if (this.tab === 0 && this.contextMenuPayload && !this.contextMenuPayload.isCompleted) {
				items.unshift({ 
					title: this.$T('add-delivery'), 
					event: 'add-delivery', 
					class: 'primary--text',
					icon: '$add', 
					iconClass: 'me-2', 
					iconColor: 'primary'
				})
			}
			if (this.tab === 1 && this.contextMenuPayload) {
				if (!this.contextMenuPayload.isDelivered) {
					items.unshift({
						title: this.$T('deliver'), 
						event: 'change-delivery', 
						class: 'primary--text',
						icon: 'mdi-truck-delivery', 
						iconClass: 'me-2', 
						iconColor: 'primary'
					});
				} else {
					return [{
						title: this.$T('cancel-delivery'), 
						event: 'change-delivery', 
						class: 'warning-color--text',
						icon: '$close',
						iconClass: 'me-2', 
						iconColor: 'warning-color'
					}]
				}
			}
			return items.filter(item => item !== null);
		},

		contractsHeaders() {
			const headers = [
				{
					text: this.$T('headers.no'),
					name: 'contractNo',
					value: 'subContractNo',
					width: 40
				},
				{
					text: this.$T('headers.client'),
					name: 'clientId',
					value: 'clientId',
					cellClass: 'text-caption',
					setValueExpr: val => this.getAccountById(val)?.name
				},
				/* {
					text: this.$T('headers.country'),
					name: 'country',
					value: 'country',
				}, */
				{
					text: this.$T('headers.deviation-percentage'),
					name: 'deviation-percentage',
					value: 'deviationPercentage',
					setValueExpr: val => (val !== null ? val : 0) + '%',
					width: 40,
					noNotAvailableText: true
				},
				{
					text: this.$T('headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					cellClass: 'text-caption',
					printValueExpr: val => val ? moment(val).format('YYYY-MM-DD') : '',
					width: 78
				},
				{
					text: this.$T('headers.completion'),
					name: 'completion',
					value: 'completion',
					width: 60,
					noNotAvailableText: true,
					cellClass: 'font-weight-bold',
					setValueExpr: val => val + '%'
				},
				{
					text: this.$T('headers.status'),
					name: 'status',
					value: 'status',
					noPrint: true
				}
			];

			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-1' : 'px-1';
				headers[i].align = 'center';
			}

			return [
				headers,
				...this.itemsHeaders,
				{
					text: this.$T('headers.total') + ' (kg)',
					name: 'total',
					value: 'total',
					align: 'center',
					width: 66,
					cellClass: 'font-weight-bold',
					columnClass: 'px-1',
					type: 'number-format',
				},
			].flat();
		},

		deliveryHeaders() {
			const headers = [
				{
					text: this.$T('headers.client'),
					name: 'clientId',
					value: 'clientId',
					setValueExpr: val => this.getAccountById(val)?.name
				},
				{
					text: this.$T('headers.contract'),
					name: 'contractNo',
					value: 'subContractNo',
					width: 40,
					noNotAvailableText: true
				},
				{
					text: this.$T('headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					cellClass: 'text-caption',
					width: 78,
					printValueExpr: val => val ? moment(val).format('YYYY-MM-DD') : '',
				},
			];

			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-1' : 'px-1';
				headers[i].align = 'center';
			}

			return [headers, ...this.itemsHeaders].flat();
		},

		itemsHeaders() {
			const subTreeItemId = this.cardamomRootId || this.itemsTree[0].id;
			if (!subTreeItemId) return;
			const subTree = this.itemsTree.find(c => c.id === subTreeItemId);

			const headers = [];
			// if(this.tab === 1 || (this.tab === 0 && ))
			const getHeaderColor = (priority) => {
				switch (priority) { 
				case 1: return 'primary-priority-1 td-style';
				case 2: return 'secondary-priority-1 td-style';
				case 3: return 'thirdly-priority-1 td-style';
				default: return 'td-style';
				}
			}
			const getCellColor = (priority) => {
				switch (priority) {
				case 1: return 'primary-priority-2 td-style';
				case 2: return 'secondary-priority-2 td-style';
				}
				if (priority < 10) {
					return `td-style thirdly-priority-${priority - 1}`
				}
				return 'td-style'
			}

			subTree.children.filter(c => c.itemCategory === itemCategory.commercial).forEach((c, i) => {
				if (c.children.length) {
					c.children.forEach(e => {
						headers.push({
							text: e.name,
							name: e.name,
							value: e.id,
							align: 'center',
							width: 58,
							type: 'number-format',
							class: getHeaderColor(i < 2 ? i + 1 : 3),
							cellClass: getCellColor(i + 1),
							columnClass: 'px-1'
						})
					});
				} else {
					headers.push({
						text: c.name,
						name: c.name,
						value: c.id,
						align: 'center',
						width: 58,
						type: 'number-format',
						class: getCellColor(i < 2 ? i + 1 : 3),
						cellClass: getCellColor(i + 1),
						columnClass: 'px-1'
					});
				}
			})

			return headers;
		},

		dialogHeaders() {
			const headers = [
				{
					text: this.$T('headers.item'),
					name: 'itemId',
					value: 'itemId',
				},
				{
					text: this.$T('headers.weight') + ' (kg)',
					name: 'weight',
					value: 'weight',
					// type: 'number',
					disableInputs: this.submitLoading || Boolean(this.$route.query.deliveryId), 
					align: 'center',
					type: 'number',
					// writable: true,
					// inputRules: [() => this.dialogData.entries.filter(c => c.weight).length > 0],
					width: 80, // 140
				}
			];

			if (this.tab === 0) {
				headers.push({
					text: this.$T('headers.price') + ' $',
					name: 'price',
					value: 'price',
					disableInputs: this.submitLoading || Boolean(this.$route.query.deliveryId),
					// inputRules: [() => this.dialogData.entries.filter(c => c.price).length > 0],
					// type: 'number',
					// writable: true, 
					width: 80, // 140
				});
			}
			
			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-2' : 'px-2';
			}
			return headers;
		},

		dialogMixesHeaders() {
			const headers = [
				{
					text: this.$T('headers.mix'),
					name: 'mixId',
					value: 'mixId',
					columnClass: 'px-2',
				},
				{
					text: this.$T('headers.weight') + ' (kg)',
					name: 'weight',
					value: 'weight',
					// type: 'number-format',
					// inputRules: [() => this.dialogData.mixes.filter(c => c.weight).length > 0],
					disableInputs: this.submitLoading,
					align: 'center',
					columnClass: 'px-2',
					width: 80, // 140
					// writable: true,
					noNotAvailableText: true
				},
				{
					text: '',
					name: 'data-table-expand',
					value: 'data-table-expand',
					columnClass: 'ps-0 pe-1',
					noInput: true,
					noNotAvailableText: true
				},
			];

			if (this.tab === 0) {
				headers.splice(headers.length - 1, 0, {
					text: this.$T('headers.price') + ' $',
					name: 'price',
					value: 'price',
					columnClass: 'px-2',
					// type: 'number-format',
					disableInputs: 
						this.submitLoading,
					// inputRules: [() => this.dialogData.mixes.filter(c => c.price).length > 0],
					width: 80, // 140
					// writable: true
				});
			}

			return headers;
		},

		flatCardamomItems() {
			if (this.cardamomRootId) {
				return getFlatTree([this.itemsTree.find(c => c.id === this.cardamomRootId)]);
			} else {
				return this.items.filter(c => c.type === type.sub);
			}
		}
	},

	methods: {
		// helpers
		updateMixData(mixItemIndex) {
			if (this.dialogData.mixes[mixItemIndex].mixId) {
				this.dialogData.mixes.push({
					id: this.dialogData.mixes.length + 1,
					mixId: null,
					weight: 0,
					price: 0,
					mixItems: [],
					formattedPrice: '', 
					formattedWeight: ''
				});
				
				this.loadingMixItems = true;
				this.$store.dispatch('items/fetchMixItems', {
					itemId: this.dialogData.mixes[mixItemIndex].mixId
				}).then(data => {
					this.dialogData.mixes[mixItemIndex].mixItems = data;
				}).finally(() => {
					this.loadingMixItems = false;
				})
			} else {
				this.dialogData.mixes[mixItemIndex].mixItems = [];
				this.dialogData.mixes.pop();
			}
		},

		getSumItemsDueKey(items, keyToSum = 'percent') {
			return items.reduce((res, a) => res + a[keyToSum], 0);
		},

		// fetch data
		filter(newScrollOptions) {
			let itemsPerPage = 20;
			let page = 1;
			if (newScrollOptions) {
				itemsPerPage = newScrollOptions.itemsPerPage;
				page = newScrollOptions.page;
			} else if (this.$refs.table) {
				this.$refs.table.resetShownRows();
			}

			this.loading = true;
			const moduleName = this.tab === 0 ? 'contracts' : 'deliveries';
			Promise.all([
				// data
				this.$store.dispatch(`${moduleName}/fetchAll`, {
					clientId: this.filterData.clientId,
					subContractNo: this.filterData.subContractNo ? this.filterData.subContractNo : null,
					// contractNo: this.filterData.contractNo ? this.filterData.contractNo : null,
					date: this.filterData.date,
					isComplete: this.filterData.noneCompletedOnly,
					ownerIds: this.filterData.ownerId ? [this.filterData.ownerId] : null,
					page,
					perPage: itemsPerPage
				}).then(({ data, total }) => {
					const tableItems = [];
					data.forEach((entry) => {
						tableItems.push({
							...entry,
							...this.itemsHeaders.reduce((res, header) => {
								const weight = toKiloGram(entry.items.find(c => c.itemId === header.value)?.weight ?? 0)
								const deliveryWeight = toKiloGram(entry.items.find(c => c.itemId === header.value)?.deliveredQty ?? 0)
								const deliveredPercentQty = entry.items.find(c => c.itemId === header.value)?.deliveredPercentQty ?? 0

								res[header.value] = this.tab === 0 
									? (weight > 0 ? deliveryWeight + ' / ' + weight : weight)
									: weight;
								res[header.percent] = deliveredPercentQty;

								res[header.val] = this.tab === 0 
									? (weight > 0 ? deliveryWeight + ' / ' + weight : weight)
									: weight;
								// res[header.value] = this.tab === 0
								// 	? `
								// 		${weight > 0 ? `<span>${deliveryWeight} / ${weight}</span>` : `<span>${weight}</span>`}
								// 		<span style="display:block; font-size:0.8em; color:gray;">
								// 			${deliveredPercentQty}%
								// 		</span>
								// 		`
								// 	: weight;
								return res;
							}, {})
						});
					});
					console.log('tableItems', tableItems)
					this.serverItemsLength = total;
					this.$refs.table.addScrollItems(tableItems);
				}),

				// statics
				this.$store.dispatch('contracts/fetchStatistics', {
					clientId: this.filterData.clientId,
					subContractNo: this.filterData.subContractNo ? this.filterData.subContractNo : null,	
					// contractNo: this.filterData.contractNo ? this.filterData.contractNo : null,
					date: this.filterData.date,
					isComplete: this.filterData.noneCompletedOnly,
					ownerIds: this.filterData.ownerId ? [this.filterData.ownerId] : null,
					page,
					perPage: itemsPerPage
				}).then(data => {
					this.totals.totalSale =
						data.totalSales.map(c => ({ [c.itemId]: toKiloGram(c.totalSales) }));
					
					this.totalSaleSum =
						data.totalSales.reduce((res, a) => res + toKiloGram(a.totalSales), 0);
				}),
				
				// this.$store.dispatch('inventory/fetchAll', { withDetails: false }).then(data => {
				// 	this.totals.inventoryQuantity = data.map(c => ({ [c.itemId]: toKiloGram(c.remainingQty) }));
				// 	this.inventoryQuantitySum = data.reduce((res, a) => res + toKiloGram(a.remainingQty), 0)
				// })
				this.fetchStatistics()
			]).finally(() => {
				this.loading = false;
			});
		},

		fetchData({ id, subContractNo: no } = {}) {
			this.contractLoading = true;
			if (this.tab === 1 && this.itemData) {
				this.$store.dispatch('contracts/fetchBySubNo', { no: no }).then(contract => {
					this.contractByNo = contract
					this.dialogData.ownerId = contract.ownerId;
				})
			} 

			const actionName =
				this.tab === 1 && this.itemData ? 'deliveries/fetchById' : 'contracts/fetchBySubNo';
			return this.$store.dispatch(actionName, { id, no }).then(data => {
				if (isEmptyId(data.id)) {
					this.$eventBus.$emit('show-snackbar', this.$T('messages.no-contract'), 'error');
					return;
				}
				this.dialogData.clientId = data.clientId;
				this.dialogData.contractId = data.contractId || data.id;
				if (!(this.tab === 1 && this.itemData)) this.dialogData.ownerId = data.ownerId;
				
				this.dialogData.entries = [];
				this.dialogData.mixes = [];

				this.dialogData.contractNo = data.contractNo

				// entires
				data.items.filter(c => !c.mixId).forEach((c, i) => {
					this.dialogData.entries.push({
						id: i + 1,
						itemId: c.itemId,
						weight: this.itemData ? toKiloGram(c.weight) : 0,
						price: c.price,
						formattedPrice: this.$options.filters.numberFormat(c.price),
						formattedWeight: this.$options.filters.numberFormat(this.itemData ? toKiloGram(c.weight) : 0),
					});
				});

				if (this.tab === 0) {
					this.dialogData.entries.push({ id: Math.random(), itemId: null, weight: 0, price: 0, formattedPrice: '', formattedWeight: '' });
				}

				// set mixes
				// if (data.items.filter(c => c.isMix).length > 0) {
				if (this.tab === 1 && this.itemData) {
					data.items.forEach((ele) => {
						if (this.contractByNo.items.find(c => c.itemId === ele.itemId)) {
							ele.percent = this.contractByNo.items.find(c => c.itemId === ele.itemId)?.percent
						}
					})
				}
				// console.log('data.items', data.items)
				data.items.filter(c => c.isMix).forEach((c, i) => {
					this.dialogData.mixes.push({
						id: i + 1,
						mixId: c.itemId,
						weight: this.itemData ? toKiloGram(c.weight) : 0,
						price: c.price,
						mixItems: data.items
							.filter(e => e.mixId === c.itemId && e.itemId !== c.itemId)
							.map(({ weight, ...data }) => ({
								weight: 0, ...data
							})),
						formattedPrice: this.$options.filters.numberFormat(c.price),
						formattedWeight: this.$options.filters.numberFormat(this.itemData ? toKiloGram(c.weight) : 0)
					});
				});
				// console.log(' mix items')
				// } 
				// else {
				// 	console.log('no mix items')
				// 	this.dialogData.mixes.push({ id: 1, mixId: null, weight: 0, price: 0, mixItems: [], formattedPrice: '', formattedWeight: '' })
				// }

				if (this.tab === 0) {
					this.dialogData.mixes.push({ id: Math.random() + 100, mixId: null, weight: 0, price: 0, mixItems: [], formattedPrice: '', formattedWeight: '' })
				}
			}).finally(() => {
				this.contractLoading = false;
			});
		},

		// submit
		submit() {
			if (this.$refs.form.validate()) {
				this.submitLoading = true;
				const moduleName = this.tab === 0 ? 'contracts' : 'deliveries';
				const actionName = !this.itemData ? 'create' : 'update';
				this.$store.dispatch(`${moduleName}/${actionName}`, {
					id: this.itemData?.id,
					contractNo: this.tab === 1 ? this.dialogData.contractNo : 0,
					subContractNo: this.tab === 0 ? this.dialogData.subContractNo : null,
					contractId: this.dialogData.contractId || null,
					date: this.dialogData.date,
					clientId: this.dialogData.clientId,
					ownerId: this.dialogData.ownerId,
					sale: this.dialogData.sale || 0,
					deviationPercentage: this.dialogData.deviationPercentage || 0,
					items: [
						...this.dialogData.entries.filter(c => c.itemId).map(c => ({
							itemId: c.itemId,
							weight: toQuintal(c.weight || 0, false),
							price: c.price || 0,
							formattedPrice: this.$options.filters.numberFormat(c.price) || '',
							formattedWeight: this.$options.filters.numberFormat(toKiloGram(c.weight || 0)) || '',
						})),
						...this.dialogData.mixes.filter(c => c.mixId).map(mix => ({
							itemId: mix.mixId,
							weight: toQuintal(mix.weight || 0, false),
							price: mix.price || 0,
							isMix: true,
							mixId: mix.mixId,
							formattedPrice: this.$options.filters.numberFormat(mix.price) || '',
							formattedWeight: this.$options.filters.numberFormat(toKiloGram(mix.weight || 0)) || '',
						})),
						...this.dialogData.mixes.reduce((res, mix) => {
							res.push(...mix.mixItems.map(mixItem => ({
								itemId: mixItem.itemId,
								weight: toQuintal((mix.weight * (mixItem.percent / 100)) || 0, false),
								price: (mix.price * (mixItem.percent / 100)) || 0,
								percent: mixItem.percent,
								mixId: mix.mixId,
								formattedPrice: this.$options.filters.numberFormat((mix.price * (mixItem.percent / 100)) || 0) || '',
								formattedWeight: this.$options.filters.numberFormat(toKiloGram((mix.weight * (mixItem.percent / 100)) || 0)) || '',
							})));
							return res
						}, [])
					],
					type: this.dialogData.type,
				}).then(() => {
					this.$eventBus.$emit(
						'show-snackbar',
						!this.itemData
							? this.$T('messages.contract-added')
							: this.$T('messages.contract-edited'),
						'info'
					);
					this.dialogData.show = false;
					this.filter();
				}).finally(() => {
					this.submitLoading = false;
				})
			}
		},

		changeDeliveryState(item) {
			this.loading = true;
			this.$store.dispatch('deliveries/updateStatus', {
				id: item.id,
				isDelivered: !item.isDelivered
			}).then(() => {
				this.filter();
			}).catch(() => {
				this.loading = false;
			})
		},

		closeContract (item) {
			this.loading = true
			this.$store.dispatch('contracts/changeStatus', { 
				contractId: this.itemData.id,
				isCompleted: !item.isCompleted
			}).then(() => {
				this.filter()
				this.closeDialog = false
			}).finally(() => {
				this.loading = false
			})
		},

		fetchStatistics () {
			if (!this.permissions.statistics.isNone) {
				this.$store.dispatch('statistics/fetchAvailableToSellByOwners', {
					ownerIds: this.filterData.ownerId ? [this.filterData.ownerId] : []
				}).then(([data]) => {
					this.statistics = [
						{
							label: this.$T('total-sales'),
							type: 'totalSale',
							values: this.itemsHeaders.map(header => {
								const found = this.totals.totalSale.find(c => c[header.value]);
								return found ? found[header.value] : 0;
							}),
							totalSum: this.tab === 0 ? this.$options.filters.numberFormat(fixNumber(this.totalSaleSum, 1)) : null
						},
						...(
							!this.permissions.statistics.isNone 
								? [
									{
										label: this.$T('sale-balance'),
										type: 'saleBalances',
										values: this.itemsHeaders.map(header => {
											const found = this.totals.saleBalances.find(c => c[header.value]);
											return found ? found[header.value] : 0;
										}),
										// totalSum: this.tab === 0 ? this.saleBalancesSum : null
										totalSum: this.tab === 0 ? this.$options.filters.numberFormat(fixNumber(this.saleBalancesSum, 1)) : null
									}] 
								: []),
						...(
							!this.permissions.statistics.isNone && !this.permissions.inventory.isNone 
								? [
									{
										label: this.$T('remaining-qty'),
										type: 'inventoryQuantity',
										values: this.itemsHeaders.map(header => {
											const found = this.totals.inventoryQuantity.find(c => c[header.value]);
											return found ? found[header.value] : 0;
										}),
										// totalSum: this.tab === 0 ? this.inventoryQuantitySum : null
										totalSum: this.tab === 0 ? this.$options.filters.numberFormat(fixNumber(this.inventoryQuantitySum, 1)) : null
									}] 
								: []),

						...(
							!this.permissions.statistics.isNone 
								? [
									{
										label: this.$T('statistics.reserved-quantity'),
										type: 'reservedQuantity',
										values: this.itemsHeaders.map(header => {
											const found = this.totals.reservedQuantity.find(c => c[header.value]);
											return found ? found[header.value] : 0;
										}),
										// totalSum: this.tab === 0 ? this.reservedQuantitySum : null
										totalSum: this.tab === 0 ? this.$options.filters.numberFormat(fixNumber(this.reservedQuantitySum, 1)) : null

									}] 
								: []),
						...(
							!this.permissions.statistics.isNone 
								? [
									{
										label: this.$T('available-to-sell'),
										type: 'ableToSell',
										values: this.itemsHeaders.map(header => {
											const found = this.totals.ableToSell.find(c => c[header.value]);
											return found ? found[header.value] : 0;
										}),
										// totalSum: this.tab === 0 ? this.ableToSellSum : null
										totalSum: this.tab === 0 ? this.$options.filters.numberFormat(fixNumber(this.ableToSellSum, 1)) : null

									}] 
								: [])
					]
					console.log('statistics', this.statistics)
					data = data.items;					

					this.totals.saleBalances =
						data.map(c => ({ [c.itemId]: toKiloGram(c.expectedQuantity) }));
					this.saleBalancesSum =
						data.reduce((res, a) => res + toKiloGram(a.expectedQuantity), 0);

					this.totals.inventoryQuantity =
						data.map(c => ({ [c.itemId]: toKiloGram(c.inventoryQuantity) }));
					this.inventoryQuantitySum =
						data.reduce((res, a) => res + toKiloGram(a.inventoryQuantity), 0);

					this.totals.reservedQuantity =
						data.map(c => ({ [c.itemId]: toKiloGram(c.reservedQuantity) }));
					this.reservedQuantitySum =
						data.reduce((res, a) => res + toKiloGram(a.reservedQuantity), 0);
					
					this.totals.ableToSell =
						data.map(c => ({ [c.itemId]: toKiloGram(c.availableToSell) }));
					this.ableToSellSum =
						data.reduce((sum, item) => sum + toKiloGram(item.availableToSell), 0);
				})
			}
		},

		fixNumber,
		toKiloGram,
		toQuintal,

		printAll(customHeaders = null, customItems = null) {
			// if custom data is provided, skip the fetch and print directly
			if (customHeaders && customItems) {
				this.generatePrintAll(customHeaders, customItems);
				return;
			}

			// default behavior: fetch all records
			this.itemsWithoutPaging = [];
			const moduleName = this.tab === 0 ? 'contracts' : 'deliveries';

			this.$store.dispatch(`${moduleName}/fetchAll`, {
				clientId: this.filterData.clientId,
				subContractNo: this.filterData.contractNo ? this.filterData.contractNo : null,
				date: this.filterData.date,
				isComplete: this.filterData.noneCompletedOnly,
				ownerIds: this.filterData.ownerId ? [this.filterData.ownerId] : null,
				usePagination: false
			}).then((data) => {
				data.forEach((entry) => {
					this.itemsWithoutPaging.push({
						...entry,
						...this.itemsHeaders.reduce((res, header) => {
							const weight = toKiloGram(entry.items.find(c => c.itemId === header.value)?.weight ?? 0);
							const deliveryWeight = toKiloGram(entry.items.find(c => c.itemId === header.value)?.deliveredQty ?? 0);

							res[header.value] = weight > 0 ? deliveryWeight + ' / ' + weight : weight;
							return res;
						}, {})
					});
				});

				this.generatePrintAll();
			});
		},

		generatePrintAll (itemsArg = null) {
			const headers = this.tab === 0 ? this.contractsHeaders.filter(c => !c.noPrint) : this.deliveryHeaders.filter(c => !c.noPrint);
			const customTitleHtml = [
				{
					text: this.$T('inputs.no'),
					value: this.filterData.contractNo,
					width: '20%',
				},
				{
					text: this.$T('inputs.client'),
					value: this.filterData.clientId ? this.customers?.find(c => c.id === this.filterData.clientId)?.name : null,
					width: '20%',
				},
				{
					text: this.$T('inputs.owner'),
					value: this.filterData.ownerId ? [{ id: emptyId, name: 'Ugarit' }, ...this.owners]?.find(c => c.id === this.filterData.ownerId)?.name : null,
					width: '20%',
				},
				{
					text: this.$T('status'),
					value: [
						{ name: this.$T('all'), value: null },
						{ name: this.$T('not-completed'), value: false },
						{ name: this.$T('completed'), value: true },
					]?.find(c => c.value === this.filterData.noneCompletedOnly)?.name,
					width: '20%',
				},
			].filter(c => c.value)
				.map(({ text, value, width }) => `
					<div style="max-width: ${width || '15%'}; margin-right: 2%; white-space: nowrap;">
						${text}: <b>${value}</b>
					</div>
				`)
				.join('');

			const html = generateHtmlPdf({
				titleData: {
					Type: 'Contract',
					Date: this.filterData.date
				},
				headers: headers.map(c => c.text),
				customTitleHtml: `<div style="display: flex; flex-wrap: wrap; margin-top: 10px;">${customTitleHtml}</div>`,
				data: this.itemsWithoutPaging.map(item =>
					headers.map(header => 
						header.printValueExpr
							? header.printValueExpr(item[header.value])
							: header.setValueExpr
								? header.setValueExpr(item[header.value])
								: item[header.value]
					)
				),
				headersHtmlStatistics: this.tab === 0 ? ['', ...this.itemsHeaders.map(c => c.text), 'total'] : ['', ...this.itemsHeaders.map(c => c.text)],
				dataHtmlStatistics: this.tab === 0 ? this.statistics.map(item => [item.label, ...item.values, item.totalSum]) : this.statistics.map(item => [item.label, ...item.values])
			});

			printJS({
				printable: html,
				type: 'raw-html',
			});
		}
	},
	
	created() {
		if (!this.permissions.inventory.isNone) {
			this.fetchStatistics()
		}
		
		if (this.$route.query.deliveryId) {
			this.tab = 1;
			this.$store.dispatch('deliveries/fetchById', { id: this.$route.query.deliveryId }).then(data => {
				this.itemData = data;
				this.dialogData.show = true;
			})
		} else {
			this.filter();
		}
	},

	/* beforeRouteEnter(to, from, next) {
		next(vm => {
			if (vm.permissions.sales.isNone) {
				next({ name: 'home', replace: true });
			}
			return true;
		});
	} */
}
</script>

<style scoped>
.background-grey {
	background-color: blue;
}

</style>

<style>
.td-style {
	font-size: 11px !important;
	font-weight: 700;
	white-space: nowrap;
}
</style>